module.exports = __webpack_public_path__ + "static/media/ru-symbol-blue.73b68abe.svg";